import {Component, Input} from '@angular/core';
import {UserState} from '../../state/user-state';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {

  @Input()
  user: UserState;

  constructor() {
  }

}
